import styled, { css } from 'styled-components';

import { ButtonBase } from '../ButtonBase';

import { type Size, Sizes } from './types';

const BUTTON_TEXT_BREAKPOINT = 'mobile';

export const StyledButtonText = styled(ButtonBase)<{ $size: Size }>`
    &&& {
        background: transparent;

        ::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 1px;
            top: 100%;
            left: 0;
            background: ${({ theme }) => theme.colors.white};
            transition: transform 0.5s;
            transform: scaleX(1);
            transform-origin: right;
        }

        :hover::after {
            transform: scaleX(0);
            transform-origin: right;
        }

        :focus,
        :hover {
            background: transparent;
        }

        ${({ theme, $size }) => {
            switch ($size) {
                case Sizes.medium: {
                    return css`
                        font-weight: 500;
                        font-size: 0.875rem;
                        line-height: 1.4285714286;
                        letter-spacing: -0.2px;

                        @media (min-width: ${theme.breakpoints[BUTTON_TEXT_BREAKPOINT]}) {
                            font-size: 1.125rem;
                            line-height: 1.3333333333;
                            letter-spacing: -0.5px;
                        }
                    `;
                }
                case Sizes.small: {
                    return css`
                        font-weight: 400;
                        font-size: 0.75rem;
                        line-height: 1;
                        letter-spacing: -0.03em;
                    `;
                }
            }
        }}
    }
`;
